/**
 * LS Electric 통합챗봇 위젯 삽입 순수 로직.
 *
 * services/cookieutil 등 전역 초기화에 의존하지 않는다 — 테스트가 서비스 싱글톤
 * side effect(i18n init, localStorage 접근) 없이 이 모듈만 import할 수 있어야 한다.
 */
import { LANG_EN, LANG_EN_US, LANG_KO_KR } from 'language/langutil';

export const CHATBOT_SCRIPT_ID = 'ls-electric-ai-chatbot';

export const CHATBOT_RELEASE_DATE = '2026-07-25T16:00:00+09:00';

export const chatbotMarketOf = (lang: string): string | null => {
  if (lang === LANG_KO_KR) return 'KR';
  if (lang === LANG_EN) return 'GLOBAL';
  if (lang === LANG_EN_US) return 'NA';
  return null;
};

export interface ChatbotWidgetConfig {
  url?: string;
  clientId?: string;
  lang: string;
  consented: boolean;
  // (ISO, 예: 2026-07-25T16:00:00+09:00)
  releaseDate?: string;
}

export const injectChatbotWidget = (cfg: ChatbotWidgetConfig, doc: Document = document): boolean => {
  const market = chatbotMarketOf(cfg.lang);
  if (!cfg.url || !cfg.clientId || !market || !cfg.consented) return false;
  if (cfg.releaseDate) {
    const releaseAt = new Date(cfg.releaseDate).getTime();
    if (!Number.isFinite(releaseAt) || Date.now() < releaseAt) return false;
  }
  if (doc.getElementById(CHATBOT_SCRIPT_ID)) return false;

  const script = doc.createElement('script');
  script.id = CHATBOT_SCRIPT_ID;
  script.src = cfg.url;
  script.defer = true;
  script.dataset.clientId = cfg.clientId;
  script.dataset.market = market;
  script.dataset.domain = 'AUTOMATION';
  script.onerror = () => {
    console.error('[chatbot-widget] script load failed:', cfg.url);
  };
  doc.body.appendChild(script);
  return true;
};
